import { inject, Injectable } from '@angular/core';
import {
  GetHotelKpisDocument,
  GetHotelKpisQueryVariables,
} from '@graphql-types';
import {
  ApolloHelperService,
  QueryResult,
} from '@shared/services/apollo-helper.service';
import type { Observable } from 'rxjs';
import type { HotelKpisQuery } from '../models/dashboard-kpi.types';

/**
 * Repositorio del dashboard de KPIs (IB-41). Expone únicamente la carga
 * de solo lectura del informe admin `hotelKpis` para un rango de fechas.
 */
@Injectable()
export class DashboardKpiGraphqlRepository {
  private readonly apolloHelper = inject(ApolloHelperService);

  fetchHotelKpis(
    variables: GetHotelKpisQueryVariables,
  ): Observable<QueryResult<HotelKpisQuery>> {
    return this.apolloHelper.fetch<HotelKpisQuery, GetHotelKpisQueryVariables>({
      query: GetHotelKpisDocument,
      variables,
      isCollection: false,
    });
  }
}
